import React, { Component } from "react";
import OperationButton from "./operation-button.jsx";
import { onXESSave } from "../../../reducers/project-state.js";
import Button from 'antd/lib/button'
import {connect} from 'react-redux';
import { XesLoadingState } from '../../../reducers/project-state'
import bindAll from 'lodash.bindall';

let toggleSaveLoading
class SaveButton extends Component {
  constructor(props) {
    super(props)
    this.state = false
    const self = this
    toggleSaveLoading = (loading) => {
      self.setState({
        loading: loading
      })
    }
    bindAll(this, [
      'toggleLoading',
      'handleClick'
    ])
  }
  toggleLoading (loading) {
    this.setState({
      loading: loading
    });
  }
  handleClick () {
    if (typeof this.props.onClick === 'function') {
      this.props.onClick()
      return
    }
    this.props.dispatch(onXESSave())
  }
  render () {
    return (
      <Button
        style={{
          color: '#4A82F7',
          borderRadius: '0.25rem',
          outline: 'none',
          border: 'none',
          fontSize: '0.88rem',
          fontWeight: '600'
        }}
        className="xes-button"
        onClick={this.handleClick}
        loading={this.state.loading}
      >
        保存
      </Button>
    );
  }
}

const mapStateToProps = (state) => ({
  state,
})
const mapDispatchToProps = (dispatch) => ({
  dispatch
})

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(SaveButton)

export {
  toggleSaveLoading
}